import React, { useRef, useEffect, useState } from "react";
import { get } from "util/requests";
import { useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import styles from "./drug_management.module.css";
import moment from "moment";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import DrugTable from "./components/drug_table";
import LoadingButton from "@mui/lab/LoadingButton";
import ModifyDrugModal from "./components/modify_drug_modal";
import BatchActionDrugModal from "./components/batch_action_drug_modal";

export default function DrugManagement() {
  const [auditLogs, setAuditLogs] = useState([]);
  const [drugs, setDrugs] = useState([]);
  const [selectedDrugs, setSelectedDrugs] = useState([]);
  const [showingDrugModal, setShowingDrugModal] = useState(false);
  const [showingBatchModal, setShowingBatchModal] = useState(false);
  const [drugConfig, setDrugConfig] = useState([]);
  const [sites, setSites] = useState([]);

  const study_id = useSelector((state) => state.user.userData.active_study_id);
  const site_ids = useSelector((state) => state.user.userData.sites);

  const fetch_data = () => {
    Promise.all([get(`/invite_user_sites_and_roles/${study_id}`), get("/drugs")]).then(([sites_roles, ret]) => {
      setDrugs(ret.data?.data);
      setDrugConfig(ret.data?.config);
      setSites(sites_roles.data.sites);
    });
  };

  useEffect(fetch_data, []);

  return (
    <div className={styles.flex}>
      <div className={styles.header}>
        <div>
          <h3>Drug Management</h3>
        </div>
        <div className={styles.button_wrapper}>
          {selectedDrugs.length > 1 ? (
            <div className={styles.batch_button_wrapper}>
              <LoadingButton
                variant="outlined"
                loading={false}
                onClick={() => setShowingBatchModal(true)}
                sx={{
                  fontSize: 14,
                  padding: "2px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              >
                BATCH ACTION
              </LoadingButton>
            </div>
          ) : null}
          <LoadingButton
            variant="contained"
            loading={false}
            onClick={() => setShowingDrugModal(true)}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            ADD
          </LoadingButton>
        </div>
      </div>
      <DrugTable
        selectedDrugs={selectedDrugs}
        setSelectedDrugs={setSelectedDrugs}
        drugConfig={drugConfig}
        drugs={drugs}
        setShowingDrugModal={setShowingDrugModal}
      />
      <ModifyDrugModal
        showingModal={showingDrugModal}
        setShowingModal={setShowingDrugModal}
        drugConfig={drugConfig}
        sites={sites}
        RefetchTableData={fetch_data}
      />
      <BatchActionDrugModal showingModal={showingBatchModal} setShowingModal={setShowingBatchModal} />
    </div>
  );
}
